<template>
  <v-row>
    <v-dialog v-model="dialog" max-width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="feedback-btn" v-bind="attrs" v-on="on">
          אז מה דעתך ?
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <div class="text-center hdr-top">
            שינינו את הסוכן החכם בשבילכם, מסוכן חכם אחד למס' סוכנים לבחירתכם.
            <br />
            נשמח לשמוע מה דעתכם
          </div>
        </v-card-title>
        <v-card-text>
          <v-row class="" align="center" justify="center">
            <v-col>
              <v-layout column class="form-wrap" pa-0 xs12>
                <v-form
                  @submit.prevent="validateFeedBack"
                  ref="formFeedback"
                  v-model="valid"
                  class="mt-1"
                  id="agentsFeedback"
                >
                  <v-flex xs12 mb-3>
                    <v-layout column>
                      <v-flex>
                        <p class="font-weight-black pb-1 text-right mb-0">
                          <span class="primary--text caption">*</span>
                          האם השימוש בסוכן החכם החדש קל ונוח?
                        </p>
                      </v-flex>
                      <v-flex>
                        <v-radio-group
                          v-model="radioGroup1"
                          row
                          hide-details
                          class="ma-0 justify-space-between"
                          :rules="radioRules"
                          required
                          color="red"
                        >
                          <v-radio
                            v-for="n in 5"
                            :key="n"
                            :value="n"
                            hide-details
                            :label="`${n}`"
                            class="ma-0"
                            color="red"
                          />
                        </v-radio-group>
                      </v-flex>
                      <v-flex>
                        <v-layout>
                          <v-flex class="caption text-right">בכלל לא</v-flex>
                          <v-flex class="caption text-left">יעיל מאוד</v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 mb-3>
                    <v-layout column>
                      <v-flex>
                        <p class="font-weight-black pb-1 text-right mb-0">
                          <span class="primary--text caption">*</span>
                          בעקבות החידוש, עד כמה אתם מרוצים מהשינוי שחל בקבלת
                          המשרות בדיוור?
                        </p>
                      </v-flex>
                      <v-flex>
                        <v-radio-group
                          v-model="radioGroup2"
                          row
                          hide-details
                          class="ma-0 justify-space-between"
                          :rules="radioRules"
                          required
                          color="red"
                        >
                          <v-radio
                            v-for="n in 5"
                            :key="n"
                            :value="n"
                            hide-details
                            :label="`${n}`"
                            class="ma-0"
                            color="red"
                          />
                        </v-radio-group>
                      </v-flex>
                      <v-flex>
                        <v-layout>
                          <v-flex class="caption text-right">לא מרוצה</v-flex>
                          <v-flex class="caption text-left">מרוצה מאוד</v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout column>
                      <v-flex>
                        <p class="font-weight-black pb-1 text-right mb-0">
                          <span class="primary--text caption">*</span>
                          עד כמה השתפרה חווית חיפוש העבודה שלכם?
                        </p>
                      </v-flex>
                      <v-flex>
                        <v-radio-group
                          v-model="radioGroup3"
                          row
                          hide-details
                          class="ma-0 justify-space-between"
                          :rules="radioRules"
                          required
                          color="red"
                        >
                          <v-radio
                            v-for="n in 5"
                            :key="n"
                            :value="n"
                            hide-details
                            :label="`${n}`"
                            class="ma-0"
                            color="red"
                          />
                        </v-radio-group>
                      </v-flex>
                      <v-flex>
                        <v-layout>
                          <v-flex class="caption text-right">לא השתפרה</v-flex>
                          <v-flex class="caption text-left">השתפרה מאוד</v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex>
                    <v-layout column pt-4>
                      <v-flex>
                        <p class="font-weight-black pb-1 text-right mb-0">
                          מה דעתכם על הוספת הסוכנים החכמים?
                        </p>
                      </v-flex>
                      <v-flex>
                        <v-textarea
                          id="textarea-feed"
                          v-model="textarea"
                          outlined
                          name="textarea"
                          label="הקלד כאן"
                          rows="2"
                          value
                          solo
                          filled
                          required="false"
                          mt-0
                        />
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex class="text-center">
                        <v-btn
                          type="submit"
                          color="primary"
                          rounded
                          class="ma-0 pl-6 pr-6"
                          :disabled="!valid"
                        >
                          שלח
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-form>
              </v-layout>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div class="text-left feedback-dialog-wrapper pointer-underline">
      <v-dialog
        v-model="dialogDone"
        max-width="360"
        width="360"
        v-if="dialogDone"
      >
        <v-card>
          <v-card-text class="pa-0">
            <v-container grid-list-md>
              <h3 class="display-18 text-center">תודה על שיתוף הפעולה</h3>
              <div class="text-center mt-2 mb-1">
                <v-icon class="icon-like1 display-20 primary--text"></v-icon>
              </div>
            </v-container>
          </v-card-text>

          <v-row class="text-center">
            <v-col class="px-0 pt-0">
              <v-btn
                color="primary "
                class="closeBtn"
                rounded
                small
                @click="closeThanksDialog"
              >
                סגור
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </div>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import { radioRules, textareaRules } from '@/lib/rules.js';
import { SMART_AGENT_FEEDBACK } from '@/lib/api.js';

export default {
  name: 'FeedbackAgents',
  computed: {
    ...mapGetters(['CurrentUser']),
  },
  data() {
    return {
      dialog: false,
      dialogDone: false,
      radioGroup1: 0,
      radioGroup2: 0,
      radioGroup3: 0,
      textarea: '',
      valid: false,
      radioRules,
      textareaRules,
    };
  },
  methods: {
    async validateFeedBack() {
      if (this.$refs.formFeedback.validate()) {
        const data = {
          Usefulness: this.radioGroup1,
          JobsImprovement: this.radioGroup2,
          SearchExperience: this.radioGroup3,
          UserFeedback: this.textarea,
          Email: this.CurrentUser.Email,
        };

        this.$nuxt.$loading.start();
        try {
          const res = await this.$axios.post(`${SMART_AGENT_FEEDBACK}`, data);
          if (res.isError) throw Error(res.isError);

          this.dialog = false;

          this.$nuxt.$loading.finish();
          this.dialogDone = true;
        } catch (e) {
          this.error = e.response.data.message;
        }
      }
    },
    async closeThanksDialog() {
      try {
        await this.$auth.fetchUser();
        this.dialogDone = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" >
.hdr-top {
  font-size: 16px;
  line-height: 1.5;
}
.form-wrap {
  padding: 0 10px;
}
#agentsFeedback .v-input--radio-group--row .v-input--radio-group__input {
  justify-content: space-between;
}
.feedback-btn {
  position: fixed;
  left: 20px;
  bottom: 20px;
  color: $primary !important;
  z-index: 10;
  background: #fff !important;
  border: 1px solid $primary;
  padding: 4px 22px;
  border-radius: 28px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
@media only screen and (min-width: 600px) {
  .hdr-top {
    font-size: 22px;
    line-height: 1.2;
  }
}
</style>
